import type { VoidFunctionComponent } from 'react';

import { getErrorMessage } from '../../../../ReactQuery';
import FallbackImage from '../../../generic/FallbackImage';

import styles from './emptyStates.module.less';

export type Props = {
  error: Error;
};

/**
 * Empty state for generic server-side errors.
 */
const GenericSnippetError: VoidFunctionComponent<Props> = ({ error }) => {
  return (
    <div className={`panel ${styles.emptyState}`}>
      <FallbackImage
        src="error-plug"
        alt="Something went wrong"
        hasPadding
      >
        <header className={styles.emptyStateHeader}>Something went wrong</header>
        <p className={styles.emptyStateMessage}>{getErrorMessage(error)}</p>
      </FallbackImage>
    </div>
  );
};

export default GenericSnippetError;
